export const rowsPerPageOptions = [10, 15, 20];
export const DEFAULT_ROWS_PER_PAGE = 10;
